export default class Formulaire_Empreinte_Carbone {
    nombre_transport = 0;
    transport_1 = {
        type: "Voiture",
        type_motorisation: "Essence",
        type_train: "TGV",
        nb_personnes: 1,
        distance: 0
    };
    transport_2 = {
        type: "Train",
        type_motorisation: "Essence",
        type_train: "",
        nb_personnes: 1,
        distance: 0
    };
    empreinte = 0;
    prix = 0;

    constructor() { }

    calculate() {
        let empreinte = 0;
        if (this.nombre_transport == 1) {
            empreinte += this.calculateTransport(this.transport_1);
        }
        else if (this.nombre_transport == 2) {
            empreinte += this.calculateTransport(this.transport_1);
            empreinte += this.calculateTransport(this.transport_2);
        }
        this.empreinte = empreinte;
        this.prix = empreinte * 0.0862;
        this.empreinte = this.empreinte.toFixed(2);
        this.prix = this.prix.toFixed(2);


    }

    calculateTransport(transport) {
        if (transport.type == 'Train') {
            return this.calculateTrain(transport);
        }
        else if (transport.type == 'Avion') {
            return this.calculateAvion(transport);
        }
        else {
            return this.calculateVoiture(transport);
        }
    }

    calculateTrain(transport) {
        let km_carb = 0;
        if (transport.type_train == 'TGV') {
            km_carb = 0.00173;
        }
        else if (transport.type_train == 'TER') {
            km_carb = 0.02481;
        }
        else if (transport.type_train == 'Intercités') {
            km_carb = 0.00529;
        }
        return km_carb * (parseFloat(transport.distance) + 40);

    }
    calculateAvion(transport) {
        const km_carb = 0.152;
        return km_carb * (parseFloat(transport.distance));
    }
    calculateVoiture(transport) {
        let km_carb = 0;
        if (transport.type_motorisation == 'Essence') {
            km_carb = 0.198;
        }
        else if (transport.type_motorisation == 'Gazole') {
            km_carb = 0.186;
        }
        else if (transport.type_motorisation == 'Hybride') {
            km_carb = 0.232;
        }
        else if (transport.type_motorisation == 'Electrique') {
            km_carb = 0.103;
        }
        else if (transport.type_motorisation == 'Bio Carburant') {
            km_carb = 0.138;
        }
        else if (transport.type_motorisation == 'GPL') {
            km_carb = 0.162;
        }
        return (km_carb * parseFloat(transport.distance)) / parseInt(transport.nb_personnes);
    }

}